module.exports = __webpack_public_path__ + "img/gsc_logo.36bd5826.svg";